<template>
  <div>
    <div id="top">
      <nav-bar />
    </div>
    <div id="content">
      <router-view :key="$route.path"></router-view>
    </div>
  </div>
</template>

<script>
import NavBar from '@/views/layouts/components/NavBar.vue'

export default {
  name: 'AdminLayout',
  data () {
    return {}
  },
  components: {
    NavBar
  }
}
</script>

<style scoped>
#content {
  min-width: 400px;
  margin-top: 14px;
}
</style>
